import { useQuery } from "@tanstack/react-query";
import axiosClient from "../../lib/axiosClient";
import { Facture } from "../../lib/interfaces/facture.interface";
import FactureAPayerItem from "./FactureAPayerItem";
import { useAutoAnimate } from "@formkit/auto-animate/react";

const BlocFacturesAPayers = () => {
  const [parent] = useAutoAnimate();
  const { data: factures } = useQuery({
    queryKey: ["factures-a-payer"],
    queryFn: async () => {
      const { data } = await axiosClient.get<Facture[]>("/factures/a-payer");
      return data;
    },
  });

  if (!factures) return <></>;
  if (factures.length === 0) return <></>;

  return (
    <div className="flex flex-col gap-3 mb-6" ref={parent}>
      {factures.map((fac) => (
        <FactureAPayerItem key={fac.id} facture={fac} />
      ))}
    </div>
  );
};

export default BlocFacturesAPayers;
